import React from 'react';

import { Box, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';

import { CustomCarousel } from '.';

const useStyles = makeStyles(() => ({
  root: {
    minWidth: 256
  },
  header: {
    padding: `4px ${24}px 0`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 220
  },
  avatar: {
    border: '4px solid rgb(229, 232, 236)',
    borderRadius: '50% !important',
    transform: 'translateY(90%)',
    '& > img': {
      margin: 0,
      backgroundColor: 'white'
    },
    '& .carousel': {
      borderRadius: '50%'
    },

    '& .carousel .slide img': {
      height: '130px' /* change this to whatever you want */,
      width: '130px',
      objectFit: 'cover'
    }
  },
  divider: {
    backgroundColor: grey[200],
    marginBottom: 24 - 1 // minus 1 due to divider height
  },
  extra: {
    textTransform: 'uppercase',
    fontSize: 14,
    color: grey[500],
    letterSpacing: '1px'
  },
  titleHeader: {
    transform: 'translateY(300%)'
  }
}));

const NftCardHeader = ({ image, token_name, attachments, logo_url }) => {
  const classes = useStyles();
  const nftImages = attachments?.filter((item) => item.attachment_type === 'NFTIMAGES');

  return (
    <div className={classes.root}>
      <Box
        className={classes.header}
        style={{
          backgroundImage: `url(${image})`
        }}>
        <CustomCarousel
          width={'130px'}
          height={'130px'}
          showThumbs={false}
          showArrows={false}
          showStatus={false}
          showIndicators={false}
          className={classes.avatar}
          transitionTime={10}
          interval={500}>
          {nftImages?.length > 0 ? (
            nftImages.map((item, index) => {
              return (
                <div key={index}>
                  <img src={item.logo_url} />
                </div>
              );
            })
          ) : (
            <div>
              <img src={logo_url} />
            </div>
          )}
        </CustomCarousel>
      </Box>
      <Typography variant="h4" noWrap textAlign="center" className={classes.titleHeader}>
        {token_name}
      </Typography>
    </div>
  );
};

NftCardHeader.propTypes = {
  image: PropTypes.string,
  extra: PropTypes.string
};
NftCardHeader.defaultProps = {
  image: '',
  extra: ''
};

export default NftCardHeader;
